




















import { Vue, Component, Watch } from 'vue-property-decorator'

@Component({
  name: 'ContentSpecial'
})
export default class extends Vue {
  showNav: boolean = true

  get editPage() {
    const activeArr: string[] = ['ContentSpecialAdd', 'ContentSpecialEdit']
    return activeArr.includes(this.$route.name as string)
  }
}
